module.exports = __webpack_public_path__ + "img/bg-events-lg.3897b335.svg";